const GROUP_ASSIGNMENTS_SELECTOR = ".js-group-assignments";
const HIGHLIGHT_CLASS = "is-url-highlighted";

function getRequestedGroupId() {
  const value = new URLSearchParams(window.location.search).get("group_id") || "";

  return /^\d+$/.test(value) && Number(value) > 0 ? value : "";
}

function getContainers(root) {
  if (root instanceof Element && root.matches(GROUP_ASSIGNMENTS_SELECTOR)) {
    return [root];
  }

  return Array.from(root?.querySelectorAll?.(GROUP_ASSIGNMENTS_SELECTOR) || []);
}

function getScrollBehavior() {
  return window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
}

export function scrollToGroupHeader(header) {
  const scrollContainer = header.closest(".table-responsive");
  const behavior = getScrollBehavior();

  if (scrollContainer instanceof HTMLElement) {
    const targetLeft = Math.max(0, header.offsetLeft - (scrollContainer.clientWidth - header.offsetWidth) / 2);
    scrollContainer.scrollTo({ left: targetLeft, behavior });
  }

  // `scrollIntoView()` adjusts the horizontal scroll position too. Its "nearest"
  // result does not account for the sticky student column, and can cover the group
  // header just after it was centered above. Scroll only the document vertically.
  const headerRect = header.getBoundingClientRect();
  window.scrollBy({
    top: headerRect.top - (window.innerHeight - headerRect.height) / 2,
    behavior,
  });
}

function focusGroup(container, groupId) {
  const header = container.querySelector(`[data-group-header-id="${groupId}"]`);
  if (!(header instanceof HTMLElement)) {
    return false;
  }

  container
    .querySelectorAll(`[data-group-header-id="${groupId}"], [data-group-column-id="${groupId}"]`)
    .forEach((element) => {
      element.classList.add(HIGHLIGHT_CLASS);
    });

  window.requestAnimationFrame(() => scrollToGroupHeader(header));

  return true;
}

export function initGroupTableGroupFocus(root = document) {
  const groupId = getRequestedGroupId();
  if (groupId === "") {
    return false;
  }

  return getContainers(root).some((container) => focusGroup(container, groupId));
}
